/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum FeedingType {
    NATURAL = 'natural',
    ARTIFICIAL = 'artificial',
}
